import ToolbarActionable from "@/mixins/toolbar-actionable";
import { formatDate } from "kinnect-formatters";
import { subDays } from "date-fns";

export default {
	name: "ReportableMixin",

	mixins: [ ToolbarActionable ],

	data: () => ( {
		toolbarActions: {
			icon: "print",
			onClick: () => window.print(),
			text: "Print Report"
		}
	} ),

	computed: {
		startDate: {
			get() {
				if ( this.$route.query.startDate ) {
					return this.$route.query.startDate;
				}

				return formatDate( subDays( new Date(), 7 ), "yyyy-MM-dd" );
			},
			set( startDate ) {
				const query = Object.assign( {}, this.$route.query, { startDate } );

				this.$router.replace( { query } );
			}
		},

		endDate: {
			get() {
				if ( this.$route.query.endDate ) {
					return this.$route.query.endDate;
				}

				return formatDate( new Date(), "yyyy-MM-dd" );
			},
			set( endDate ) {
				const query = Object.assign( {}, this.$route.query, { endDate } );

				this.$router.replace( { query } );
			}
		}
	}
};
